import type * as React from "react";
import { StatefulDropdown } from "./StatefulDropdown";
import { trafficChannelsService } from "app/services/TrafficChannelsService";

import I18n from "pro-features/components/WithTranslation/src/I18n";
interface IDashboardWizardChannelSelectionProps {
    isActive: boolean;
    selectedChannel: string;
    changeChannel: (channel: string) => void;
    widgetWebSource: string;
    widgetDuration: string;
}

const DashboardWizardChannelSelection: React.FC<IDashboardWizardChannelSelectionProps> = ({
    isActive,
    selectedChannel,
    changeChannel,
    widgetWebSource,
    widgetDuration,
}) => {
    const onSelect = (item) => {
        changeChannel(item);
    };
    if (isActive) {
        return (
            <div className="channels">
                <h5>
                    <I18n>home.dashboards.wizard.trafficSource.channels.title</I18n>
                </h5>
                <StatefulDropdown
                    key={"trafficChannels"}
                    items={trafficChannelsService
                        .getAvailableTrafficChannels(
                            trafficChannelsService.isUnifiedSearchChannelsType(widgetWebSource, widgetDuration),
                        )
                        .map((item) => ({
                            id: item.id,
                            text: item.text,
                        }))}
                    selectedId={selectedChannel}
                    onSelect={onSelect}
                />
            </div>
        );
    } else {
        return null;
    }
};

export default DashboardWizardChannelSelection;
